import styles from './index.module.scss';

const Footer = () => {
  return (
    <footer className={styles.pageFooter} role="contentinfo">
      <div className={styles.legalLinkContainer}>
        <a href="https://www.buzzfeed.com/about/privacy" className={styles.legalLink}>Privacy Policy</a>&nbsp;|&nbsp;
        <a href="https://www.buzzfeed.com/about/useragreement" className={styles.legalLink}>User Agreement</a>
      </div>
    </footer>
  );
};

export default Footer;